import type { ITheme } from "survey-core";
import { DefaultLightPanelless } from "survey-core/themes";

/**
 * How a patient form looks in the portal: a plain white page with no box around each question
 * (like a paper form), in the portal's own font and colors (DESIGN.md): ink text, navy for a
 * chosen answer. The red Complete button and the text block rules live in form-handler-survey.css.
 */
export const patientFormTheme: ITheme = {
  ...DefaultLightPanelless,
  cssVariables: {
    ...DefaultLightPanelless.cssVariables,
    "--sjs-primary-backcolor": "rgba(42, 64, 100, 1)",
    "--sjs-primary-backcolor-light": "rgba(42, 64, 100, 0.08)",
    "--sjs-primary-backcolor-dark": "rgba(30, 37, 43, 1)",
    "--sjs-general-forecolor": "rgba(30, 37, 43, 1)",
    "--sjs-general-dim-forecolor": "rgba(30, 37, 43, 1)",
    "--sjs-general-forecolor-light": "rgba(111, 115, 117, 1)",
    "--sjs-general-dim-forecolor-light": "rgba(111, 115, 117, 1)",
    "--sjs-border-default": "rgba(226, 226, 236, 1)",
    "--sjs-corner-radius": "8px",
    "--sjs-font-family": "'Nunito', sans-serif",
  },
};
